'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactIntl = require('react-intl');

var _reactRouterRedux = require('react-router-redux');

var _url = require('url');

var _url2 = _interopRequireDefault(_url);

var _DefaultString = require('../../helpers/DefaultString');

var _Router = require('../../helpers/Router');

var _ErrorRetry = require('./ErrorRetry.scss');

var _ErrorRetry2 = _interopRequireDefault(_ErrorRetry);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ErrorRetry = (_dec = (0, _reactRedux.connect)(function () {
  return {};
}, { pushState: _reactRouterRedux.push }), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(ErrorRetry, _Component);

  function ErrorRetry() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ErrorRetry);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ErrorRetry.__proto__ || (0, _getPrototypeOf2.default)(ErrorRetry)).call.apply(_ref, [this].concat(args))), _this), _this.componentDidMount = function () {
      var query = _url2.default.parse(window.location.href, true).query;
      if (query.e) {
        console.log('Error = ' + query.e);
      }
    }, _this.navigateToWelcome = function () {
      _this.props.pushState((0, _Router.getPath)(_Router.RouterConst.Welcome));
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ErrorRetry, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: _ErrorRetry2.default.errorRetryComponent },
        _react2.default.createElement(
          'div',
          { className: _ErrorRetry2.default.title },
          _react2.default.createElement(_reactIntl.FormattedMessage, _DefaultString.translations.ErrorRetryTitle)
        ),
        _react2.default.createElement(
          'div',
          { className: _ErrorRetry2.default.text },
          _react2.default.createElement(_reactIntl.FormattedMessage, _DefaultString.translations.ErrorRetryText)
        ),
        _react2.default.createElement(
          'div',
          { className: _ErrorRetry2.default.link, onClick: this.navigateToWelcome },
          _react2.default.createElement(_reactIntl.FormattedMessage, _DefaultString.translations.BackToWelcomePage)
        )
      );
    }
  }]);
  return ErrorRetry;
}(_react.Component), _class2.propTypes = {
  pushState: _react.PropTypes.func.isRequired
}, _temp2)) || _class);
exports.default = ErrorRetry;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/ErrorRetry/ErrorRetry.js
// module id = 2005
// module chunks = 0